var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ValidationObserver',{ref:"observer",attrs:{"slim":""}},[_c('UserInfo',{attrs:{"user":_vm.wipUser,"included":_vm.wipIncluded,"loading":_vm.submitting},on:{"submit":_vm.onUserInfoSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }